import { typeBuilder } from 'base/shared/TypeHelper';

export default typeBuilder([
  'HOME_ERROR',
  'HOME_REQUEST',
  'HOME_SUCCESS',
  'BADI_PLUS_COLLECTION_REQUEST',
  'BADI_PLUS_COLLECTION_SUCCESS',
  'BADI_PLUS_COLLECTION_ERROR',
  'ROOM_COLLECTIONS_BY_PLACE_IDS_REQUEST',
  'ROOM_COLLECTIONS_BY_PLACE_IDS_SUCCESS',
  'ROOM_COLLECTIONS_BY_PLACE_IDS_ERROR',
]);
